import { Divider } from '@mui/material';
import AiSearchContent from './AiSearchContent';
import { ContactForm } from './ContactForm';
import SearchSection from './SearchSection';
import VerticalTabs from './VerticalTabs';

const tabs = [
    { name: 'AI Search', component: <AiSearchContent /> },
    { name: 'Contact Form', component: <ContactForm /> },
];

const Customization = () => {
    return (
        <div className="bg-white rounded-lg shadow-sm min-h-screen my-8">
            <div className="bg-[#DADADA]/10 rounded-lg p-3">
                <SearchSection isInputDisabled />
            </div>
            <Divider />
            <div className="flex min-h-screen">
                <VerticalTabs tabs={tabs} />
            </div>
        </div>
    );
};

export default Customization;
